import type { InputProps } from 'antd'
import { Input } from 'antd'
import * as styles from './mobile-input.module.scss'

export const MobileInput = (props: InputProps) => {
    return (
        <div className={styles.inputCard}>
            <Input className={styles.mobileInput} {...props} />
        </div>
    )
}
